import { gql } from "@apollo/client/core";
/**
 *  Gets page data of each page within publication
 */
export const PAGE_QUERY = gql`
query Deprecated ($params1: GetPageViewCountParams, $params: PublicationParams) {
	Deprecated (params: $params) {
		 getPageViewCount (params: $params1) {
			publicationId
			pageId
			pageViewCount
			uniquePageViewCount
		}
	}
}
`;
/**
 *  Gets only the pageID of each page
 */
export const PAGE_ID_QUERY = gql`
query Deprecated ($params1: GetPageViewCountParams, $params: PublicationParams) {
	Deprecated (params: $params) {
		 getPageViewCount (params: $params1) {
			pageId
		}
	}
}
`;